import { SkeletonItem, Text, Link } from "@fluentui/react-components";
import RecommendedSkeleton from "./recommended-skeleton";
import { LeftArrow, RightArrow } from "../../../assets";
import { componentConstants } from "../../../utility/app-constants";
import Carousel from 'better-react-carousel'
import { Key } from "react";
import RecommendedCarouselCard from "./recommended-carousel";
import { IRecommendedCardProps } from "../../../hooks/types";
import { _blank } from "../../../utility/app-constants";
import RecommendedNoCard from "./recommended-nocard";
import { Open16Regular } from "@fluentui/react-icons";
import ComponentErrorScreen from "../error-screens/component-error-screen";

/**
 * To display all the Recommended items in a card
 * @param props 
 */
export default function Recommended(props: IRecommendedCardProps) {
  return (
    <div className={props.isRecommendedVisible ? "recommended-container" : "recommended-container skeleton"}>
      <div className={props?.isPromotionAPIError ? "recommended-header error-screen" : "recommended-header"} data-testid="recommended-hover">
        {
          props.isRecommendedVisible ? (
            <><Text className="text" data-testid="recommended-header">  {componentConstants.recommendedTitle} </Text>
              <div className="view-link">
                <Link href={componentConstants.linkHrefUrl} className="link-text" target={_blank}>
                  {componentConstants.viewAllLinkText}
                  <Open16Regular className="recommended-view-link-img" />
                </Link>
              </div></>
          ) : (
            <SkeletonItem className={"recommended-top-header-skeleton"} appearance="translucent" size={16} />
          )
        }
      </div>
      {
        props.isRecommendedVisible ? (
          props.data.length > 0 ? (
            <Carousel
              className="recommended-carousel"
              cols={3}
              rows={1}
              gap={25}
              arrowLeft={<img src={LeftArrow} className="carousel-left-arrow" alt="arrow" />}
              arrowRight={<img src={RightArrow} className="carousel-right-arrow" alt="arrow" />}
              showDots={props.data?.length > 3 ? true : false}
            >
              {
                props.data?.map((value, i: Key) => (
                  <Carousel.Item key={i}>
                    <RecommendedCarouselCard value={value} />
                  </Carousel.Item>
                ))
              }
            </Carousel>
          ) : (
            props?.isPromotionAPIError ? <ComponentErrorScreen /> : <RecommendedNoCard />
          )
        ) : (props?.isPromotionAPIError ? <ComponentErrorScreen /> :
          <>
            <div className="recommended-card-container">
              {
                [0, 1, 2].map((_, i) => (
                  <RecommendedSkeleton key={i} />
                ))
              }
            </div>
            <div className="recommended-footer">
              <SkeletonItem appearance="translucent" className="recommended-top-footer-skeleton" shape="rectangle" size={16} />
            </div>
          </>
        )
      }
    </div>
  );
}